"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "renderMenuTrigger_unstable", {
    enumerable: true,
    get: function() {
        return renderMenuTrigger_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _menuTriggerContext = require("../../contexts/menuTriggerContext");
const renderMenuTrigger_unstable = (state)=>{
    return /*#__PURE__*/ _react.createElement(_menuTriggerContext.MenuTriggerContextProvider, {
        value: state.isSubmenu
    }, state.children);
};
